var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReminderEmailVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.48,
  cy: 12.48,
  r: 12.48,
  fill: "#94C843"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.805 7.034h-.666v-1.21h-1.33v1.21H9.151v-1.21H7.821v1.21h-.666c-.732 0-1.33.545-1.33 1.21v9.682c0 .666.598 1.21 1.33 1.21h10.65c.732 0 1.331-.544 1.331-1.21V8.245c0-.666-.599-1.21-1.331-1.21Zm0 10.892H7.155V10.06h10.65v7.866Z",
  fill: "#fff"
})));
export { SvgReminderEmailVector as ReactComponent };
export default __webpack_public_path__ + "images/reminder-email-vector.svg";